import React from 'react'

const SeatClassesIcon = ({ attributeId }) => {
    if (!attributeId) {
        return ''
    }

    if (attributeId === '6') {
        //will be displayed via CSS
        return ""
    } else {
        return ''
    }
}

export default SeatClassesIcon